import React from 'react';
import { Col, Row } from '../../grid';
import { dateTypes } from '../../../features/commerce/delivery/dates/shared';
import { isToday, isTomorrow } from '../../../lib/date';
import { Span } from '../../typography';
import TimesSelect from './TimesSelect';


const DateText = ({ date, dateType }) => {
  if (isToday(date)) {
    return (
      <Span fontSize="12px">
        {dateType === dateTypes.pickup && 'Afhentning '}
        {dateType === dateTypes.delivery && 'Levering '}
        til i dag kræver telefonisk aftale efter bestilling.
        Vi ringer dig op når vi har fået din ordre og aftaler nærmere.
      </Span>
    );
  }
  return (
    <Span fontSize="12px">
      {isTomorrow(date) && dateType === dateTypes.delivery && (
        <React.Fragment>
          Bestilling til dagen efter skal foretages inden kl. 16. Efter kl. 16 kræver bestilling til dagen efter telefonisk aftale
          <br /><br />
        </React.Fragment>
      )}
      {dateType === dateTypes.pickup && 'Afhentning '}
      {dateType === dateTypes.delivery && 'Levering '}
      søndag kræver telefonisk aftale efter bestilling.
      Vi ringer dig op når vi har fået din ordre og aftaler nærmere.
    </Span>
  );
};

export default ({
  value,
  onChoose,
  error,
  getTimeFee,
  disabled,
  date,
  choices,
  dateType,
}) => (
  <Row>
    <Col xs={12} paddingTop="0px">
      <TimesSelect
        value={value}
        onChange={({ target: { value } }) => onChoose(value)}
        error={error}
        disabled={disabled}
      >
        {choices.map(
          value => <option value={value} key={value}>{getTimeFee(value)}</option>,
        )}
      </TimesSelect>
      <DateText date={date} dateType={dateType} />
    </Col>
  </Row>
);
